import { Grid, makeStyles, Typography } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/GetApp';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from 'components/Button';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import formStyles from '../ListServers/styles';
import screenFields from './formFields';
import validationSchema from './schema';

const useStyles = makeStyles(formStyles);

const initial = {
  password: '',
};

export interface Props {
  onCancel: () => void;
  onSubmit: (values: { password: string }) => void;
}

export default function FormConnectAs({ onCancel, onSubmit }: Props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (values: { password: string }) => {
    setLoading(true);
    onSubmit(values);
  };

  return (
    <Grid item container data-testid={'autosky-formconnectas'}>
      <Formik
        initialValues={initial}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1">
                {i18n.t('ENVIRONMENTS_PAGE.MODAL_CONNECT_LIKE_TITLE_KEY')}
              </Typography>
            </Grid>

            <GenericForm
              fields={values}
              screenFields={applyI18n(screenFields, i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />

            <Grid item xs={12}>
              <Alert severity="info" icon={false}>
                <AlertTitle color="secondary">{i18n.t('RDP_KEY')}</AlertTitle>
                {i18n.t('ENVIRONMENTS_PAGE.MODAL_CONNECT_LIKE_RDP_KEY')}
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<DownloadIcon />}
                  className={classes.buttonDownload}
                  href="https://skyoneautoskyplugin.s3.amazonaws.com/pacotes/ultima-versao/setup-apl.msi"
                >
                  {i18n.t('DOWNLOAD_KEY')}
                </Button>
              </Alert>
            </Grid>

            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button
                  id="submit-button"
                  onClick={submitForm}
                  isLoading={loading}
                  submitButton
                >
                  {i18n.t('CONNECT_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
}
